"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAngularCommonConfig = void 0;
var helpers_1 = require("../../../helpers");
function generateAngularCommonConfig(options, deps) {
    var mfeSettings = options.mfeSettings, PACKAGE = options.PACKAGE, distPath = options.distPath, getPackageVersion = options.getPackageVersion;
    var webpack = deps.webpack, require = deps.require;
    var commonConfig = {
        devtool: "source-map",
        plugins: __spreadArray([], helpers_1.WebpackHelper.getPluginsFrom({ webpack: webpack }), true),
        resolve: {
            fallback: helpers_1.WebpackHelper.getFallbackFrom({ require: require }),
        },
    };
    return __assign(__assign({}, mfeSettings), { distPath: distPath, remotePath: "/" + mfeSettings.__mfeName__ + "/", config: commonConfig, sharedModuleFederationDeps: helpers_1.ModuleFederationHelper.buildAngularSharedModuleFederationDeps(PACKAGE, helpers_1.ModuleFederationHelper.BASE_ANGULAR_EAGER_DEPS, getPackageVersion) });
}
exports.generateAngularCommonConfig = generateAngularCommonConfig;
